import './forms.css'
import React from 'react'
import { Field, reduxForm } from 'redux-form'
import { FormGroup, Row, Col } from 'react-bootstrap'
import { renderField, renderSelect } from './_fieldRenderer'

class CorporateForm extends React.Component {

    render() {
        const { handleSubmit } = this.props

        return (
            <form onSubmit={handleSubmit}>
                <Row>
                    <Col md={6}>
                        <FormGroup>
                            <Field
                                name='name'
                                type='text'
                                component={renderField}
                                label='Nome'
                                placeholder='Nome'
                            />
                        </FormGroup>
                    </Col>

                    <Col md={6}>
                        <FormGroup>
                            <Field
                                name='active'
                                component={renderSelect}
                                options={[
                                    { value: true, label: 'Ativo' },
                                    { value: false, label: 'Fora de Linha' }
                                ]}
                                label='Status'
                                placeholder={'Selecione'}
                            />
                        </FormGroup>
                    </Col>
                </Row>
            </form >
        )
    }

}

const validate = values => {
    const errors = {}
    if (!values.name) { errors.name = 'Obrigatório' }
    if (!values.active) { errors.active = 'Obrigatório' }

    return errors
}

CorporateForm = reduxForm({ form: 'CorporateForm', validate })(CorporateForm)
export default CorporateForm



// WEBPACK FOOTER //
// ./src/forms/CorporateForm.jsx